// @ts-nocheck
/** Gauntlet cursor — CSS `url()` in the open, tiny canvas only at viewport edges. */
export const CURSOR_DEFAULT_IMG = new Image();
CURSOR_DEFAULT_IMG.src = "sprites/cursors/default.png";

export const CURSOR_CLICK_IMG = new Image();
CURSOR_CLICK_IMG.src = "sprites/cursors/click.png";

const CURSOR_W = 51;
const CURSOR_H = 51;

/** hx/hy = hotspot on sprite (tracks the mouse). ox/oy = extra draw nudge in sprite pixels. */
export const CURSOR_FRAMES = {
  default: { img: CURSOR_DEFAULT_IMG, hx: 5, hy: 4, ox: 0, oy: 0 },
  click: { img: CURSOR_CLICK_IMG, hx: 2, hy: 1, ox: 0, oy: 0 },
};

let cursorCanvas = null;
let cursorCtx = null;
let edgeRepaint = null;

function notifyEdgeRepaint() {
  if (edgeRepaint && cursorReady()) edgeRepaint();
}

CURSOR_DEFAULT_IMG.addEventListener("load", notifyEdgeRepaint);
CURSOR_CLICK_IMG.addEventListener("load", notifyEdgeRepaint);

/** Repaint the edge canvas when sprites finish loading (if the pointer is in an edge zone). */
export function setEdgeCursorRepaint(fn) {
  edgeRepaint = fn;
  notifyEdgeRepaint();
}

export function initCursorOverlay() {
  cursorCanvas = document.getElementById("gameCursor");
  if (!cursorCanvas) return;
  cursorCanvas.width = CURSOR_W;
  cursorCanvas.height = CURSOR_H;
  cursorCtx = cursorCanvas.getContext("2d");
}

export function cursorReady() {
  const def = CURSOR_DEFAULT_IMG;
  const clk = CURSOR_CLICK_IMG;
  return def.complete && def.naturalWidth > 0
    && clk.complete && clk.naturalWidth > 0;
}

/** Browsers drop custom CSS cursors when the image would extend past the viewport. */
export function cursorNeedsEdgePaint(x, y, down) {
  const f = CURSOR_FRAMES[down ? "click" : "default"] || CURSOR_FRAMES.default;
  const w = window.innerWidth;
  const h = window.innerHeight;
  return x < f.hx || y < f.hy
    || x > w - (CURSOR_W - f.hx) || y > h - (CURSOR_H - f.hy);
}

function hideEdgeCursor() {
  if (!cursorCanvas) return;
  cursorCanvas.style.display = "none";
  if (cursorCtx) cursorCtx.clearRect(0, 0, CURSOR_W, CURSOR_H);
}

function paintEdgeCursor(x, y, down) {
  if (!cursorCanvas || !cursorCtx || !cursorReady()) return;
  const f = CURSOR_FRAMES[down ? "click" : "default"] || CURSOR_FRAMES.default;
  const im = f.img;
  cursorCanvas.style.display = "block";
  cursorCanvas.style.left = (x - f.hx) + "px";
  cursorCanvas.style.top = (y - f.hy) + "px";
  cursorCtx.clearRect(0, 0, CURSOR_W, CURSOR_H);
  const ox = f.ox || 0;
  const oy = f.oy || 0;
  const smooth = cursorCtx.imageSmoothingEnabled;
  cursorCtx.imageSmoothingEnabled = false;
  cursorCtx.drawImage(im, ox, oy, im.naturalWidth, im.naturalHeight, ox, oy, CURSOR_W, CURSOR_H);
  cursorCtx.imageSmoothingEnabled = smooth;
}

/** CSS gauntlet everywhere except viewport edges, where a clipped canvas takes over. */
export function syncGauntletCursor(x, y, down, over) {
  const root = document.documentElement;
  if (!over) {
    root.classList.remove("cursor-edge");
    hideEdgeCursor();
    return;
  }
  if (cursorNeedsEdgePaint(x, y, down)) {
    root.classList.add("cursor-edge");
    paintEdgeCursor(x, y, down);
  } else {
    root.classList.remove("cursor-edge");
    hideEdgeCursor();
  }
}
